import { getCouponIndices } from '../../../../../schema/coupon/entry.js';
import { useSubscribedCouponCollection } from './useSubscribedCouponCollection.js';
/**
 * Hook that returns active coupon indices.
 *
 * @param root0 Hook args
 * @param root0.couponId Unique coupon ID
 * @returns population function
 */
export function useCouponIndices({ couponId }) {
    const couponIndices = useSubscribedCouponCollection({
        couponId,
        selector: (collection) => getCouponIndices(collection ?? []),
    });
    return couponIndices;
}
//# sourceMappingURL=useCouponIndices.js.map